// extracted by mini-css-extract-plugin
export default {"button":"_34ZFMhNBrt7SjOJZlscz7C","infoContainer":"_2v4fyYitsdQofNEutYtD9V","infoIcon":"_34WHLDjkQr5j7Xp4Uozc2R"};